import { useTranslation } from '@sib/i18n';
import { Loader } from '@sib/ui';

interface OrganizationListLoaderProps {
  size?: 'sm' | 'md';
}

export const OrganizationListLoader = ({
  size = 'sm',
}: OrganizationListLoaderProps) => {
  const { t } = useTranslation();

  return size === 'sm' ? (
    <div className="flex h-[46px] w-full items-center justify-center gap-2 px-3">
      <Loader className="text-primary size-6 opacity-50" />
      <p className="text-primary text-sm font-semibold">{t('loading')}...</p>
    </div>
  ) : (
    <div className="flex h-full grow items-center justify-center">
      <Loader className="text-primary size-24 opacity-50" />
    </div>
  );
};
